import React from 'react'
import { Link } from "react-router-dom"
import { FaStar } from "react-icons/fa";
import { addToWishlistUtil, removeFromWishlistUtil, fetchWishlistUtil } from '../../utils/utilFuncs';
import { AuthContext } from '../../utils/AuthContext';
import { MdFavoriteBorder, MdFavorite } from "react-icons/md";
import Loader from '../../utils/Loader';

function ServiceCard({ item }) {

    const { user, isLogin } = React.useContext(AuthContext);
    const [isInWishlist, setIsInWishlist] = React.useState(false);
    const [isWishlistLoading, setWishlistLoading] = React.useState(true);

    React.useEffect(() => {
        async function checkWishlist() {
            setWishlistLoading(true);
            const wishlist = await fetchWishlistUtil(user);
            if (wishlist) {
                let isServiceInWishlist = false;
                wishlist.services.forEach(service => {
                    if (service._id === item._id)
                        isServiceInWishlist = true;
                });
                setIsInWishlist(isServiceInWishlist);
            }
            setWishlistLoading(false);
        }
        checkWishlist();
    }, [user, item._id]);

    const handleWishlistClick = async (e) => {
        if (isWishlistLoading)
            return;
        setWishlistLoading(true);
        if (isInWishlist) {
            await removeFromWishlistUtil(e, item._id, "service", user);
            setIsInWishlist(false);
        } else {
            await addToWishlistUtil(e, item._id, "service", user);
            setIsInWishlist(true);
        }
        setWishlistLoading(false);
    };

    return (
        <Link
            to={`/postingDetails/${item._id}`}
            className="service"
        >
            <div className="serviceContent">
                <div className="serviceImgDiv">
                    {item.serviceImages && <img src={`${item.serviceImages[0]}`} alt="Service Thumbnail" loading='lazy' />}
                </div>
                <h2 className='serviceTitle'>{item.title}</h2>
                <div className="serviceLower">
                    <div className='serviceLowerTop'>
                        <FaStar className='starIconFilled' />
                        <p>{item?.rating?.toFixed(1)}</p><span>({item.noOfReviews})</span>
                    </div>
                    <div className="serviceLowerBottom">
                        {/* {item.discountPercent !== 0 && <p className='serviceDiscount'>{`$${item.price}`}</p>} */}
                        <p>Starting at</p>
                        {item.packages && <h1 className="servicePrice">{`$${item.discountPercent === 0 ? item.packages[0].price.toFixed(2) : item.packages[0].salesPrice.toFixed(2)}`}</h1>}
                    </div>
                </div>
                {isLogin && <div className="hoverActions">
                    <div className={isWishlistLoading ? "loading" : "iconDiv"} onClick={(e) => handleWishlistClick(e)}>
                        {isWishlistLoading ? <Loader type="miniPlus" /> : isInWishlist ? <MdFavorite /> : <MdFavoriteBorder />}
                    </div>
                </div>}
            </div>
        </Link>
    )
}

export default ServiceCard